import { createApi } from "../../../../utils/createApi";
import { saveAs } from "file-saver";

// "Download Site Details" (site About header): the per-site settings
// report as a PDF — technical overview, camera table, schedule grid.
export const downloadSiteDetails = async (
  siteId: string | number,
  siteName?: string
) => {
  const AxiosUI = createApi("");
  const response = await AxiosUI.get(`site_settings_report/${siteId}/pdf/`, {
    responseType: "blob",
  });
  const blob = new Blob([response.data], { type: "application/pdf" });
  const name = (siteName || `site_${siteId}`)
    .replace(/[^a-zA-Z0-9-_ ]/g, "")
    .trim()
    .replace(/\s+/g, "_");
  saveAs(blob, `${name}_site_details.pdf`);
};
